// components/AsyncSelector/index.js
import AsyncSelector from './AsyncSelector'

export default AsyncSelector
export { AsyncSelector }